import React from "react"

const StarCircleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5184 16.5699L11.2627 16.1787C11.7245 15.9356 12.2765 15.9356 12.7383 16.1787L13.4826 16.5699C14.017 16.8508 14.6645 16.8043 15.1533 16.4498V16.4498C15.6414 16.0955 15.8857 15.4946 15.7836 14.9002L15.6415 14.0709C15.5545 13.5574 15.725 13.034 16.0977 12.6703L16.698 12.084C17.1297 11.6628 17.2848 11.0329 17.0981 10.4593V10.4593C16.9116 9.88507 16.4151 9.46656 15.8176 9.3799L14.9852 9.25885C14.4685 9.18416 14.0217 8.85973 13.7907 8.39149L13.4166 7.63517C13.1517 7.09397 12.6026 6.75001 12 6.7478V6.7478C11.3969 6.7478 10.8461 7.09023 10.5794 7.63117L10.2073 8.38548C9.97627 8.85389 9.52957 9.17862 9.01276 9.25385L8.18041 9.3739C7.5823 9.4603 7.08511 9.87877 6.89788 10.4533V10.4533C6.71118 11.0269 6.86631 11.6568 7.29804 12.078L7.89829 12.6653C8.27113 13.0289 8.44165 13.5524 8.35448 14.0659L8.21242 14.8952C8.11018 15.4904 8.35494 16.092 8.84369 16.4468V16.4468C9.3326 16.8043 9.98246 16.8521 10.5184 16.5699Z"
        stroke="#222222"
        strokeWidth="1.55001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="9.00375"
        stroke="#222222"
        strokeWidth="1.55001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default StarCircleIcon
